<!-- 网站地图 -->
<template>
    <div id="webMap">
        <headerVue></headerVue>
        <div class="container">
            <div class="title">网站地图</div>
            <!-- 循环 -->
            <div class="content" v-for="(item,index) in firstList" :key="item.id">
                <!-- 一级菜单 -->
                <div class="smallTitle">
                    <p>{{ item.navName }}</p>

                </div>
                <!-- 二级菜单循环 -->
                <div class="list">
                    <span class="item" v-for="(item,index) in secondList[index]" :key="index" @click="toDetail(item.id,item.navName)">{{ item.navName}}</span>
                </div>
            </div>
            <!-- <div class="content">
                <div class="smallTitle">
                    <p>本社介绍</p>
                </div>
                <div class="list">
                    <div class="item">九三简介</div>
                    <div class="item">九三章程</div>
                    <div class="item">九三章程</div>
                    <div class="item">九三章程</div>
                    <div class="item">九三章程</div>
                </div>
            </div> -->
        </div>
        <footerVue></footerVue>
    </div>
</template>

<script>
import headerVue from '../index/header.vue'
import footerVue from '../foot/foot.vue'
export default {
    name: 'webMap',
    data() {
        return {
            firstList:[],
            secondList:[]
        }
    },
    created(){
        this.getFirstNav()
    },
    methods: {
        async toDetail(_id,currentName){
            if(currentName == '联系我们'){
                this.$router.push(`/AboutUs`)
            }else{
                this.$router.push(`/newsSecondDetail?tm=${_id}&navName=${currentName}`)
            }
            // this.$router.push({ name: "routeSecond", params: { id: _id } });
        },
        async getFirstNav(){
            let res = await this.$api.nav.getNavList(1,0)
            this.firstList = res.data.data
            // console.log(this.firstList);
            this.getSecondNav()
        },
        async getSecondNav(_id){
            // console.log(111111111);
            this.firstList.map(async item=>{
                let res = await this.$api.nav.getNavList(1,item.id)
                // console.log(res.data.data);
                

                this.secondList.push(res.data.data)
            })
        }
    },
    components: {
        headerVue,
        footerVue
    }
}
</script>

<style lang="scss" scoped>
.container {
    width: 1200px;
    margin: auto;
    background-color: white;
    margin-top: 20px;

    .title {
        padding: 10px;
        padding-bottom: 20px;
        font-size: 20px;
        text-align: center;
        letter-spacing: 1px;
    }
    .content {
        .smallTitle {
            padding: 15px 15px 15px 20px;
            width: 1100px;
            margin: auto;
            background-color: #EFEFEF;
            p{
                border-left: 4px solid #1C74CD;
                padding-left: 10px;
                color:#1C74CD;
                font-weight: bolder;
            }
        }
        .list {
            display: flex;
            padding: 15px 15px 15px 20px;
            width: 1100px;
            margin: auto;
            border-bottom: 1px solid #EFEFEF;
            margin-bottom: 20px;
            .item{
                margin-right: 60px;
                transition: all .5s linear;
                &:hover{
                    transition: all .2s linear;
                    color:#1C74CD;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>
